import { cn } from "@/lib/utils";
import type { Experimental_GeneratedImage } from "ai";

export type ImageProps = Partial<Experimental_GeneratedImage> & {
  className?: string;
  alt?: string;

  url?: string;
};

export const Image = ({
  base64,
  uint8Array,
  mediaType,
  url,
  ...props
}: ImageProps) => (
  <img
    {...props}
    alt={props.alt}
    className={cn(
      "h-auto max-w-full overflow-hidden rounded-md",
      props.className
    )}
    src={url ?? `data:${mediaType};base64,${base64}`}
  />
);
